export default "__VITE_ASSET__CTjjgK9H__"